import IAuthState from '../../../interfaces/IAuthState'
import {consts} from '../../../common/consts'
import CalloutStatuses from '../types/CalloutStatuses';

const getRoles = (authStore: IAuthState) => {
    const permissions = {
        canMakeBooking: authStore?.data?.role?.split(',')?.some(p => p == consts.Permissions.MakeBooking || p == consts.Permissions.SMAMakeBooking),
        canViewScheduleAsSMA: authStore?.data?.role?.split(',')?.some(p => p == consts.Permissions.SMAViewSchedule),
    }
    const roles = {
        isAdmin: authStore?.data?.IsAdmin || false,
        SMADriver: authStore?.data ? authStore?.data?.role?.indexOf(consts.Permissions.SMADriver) >= 0 ? true : false : false,
    }
    return {
        assignText: roles.isAdmin ? "Assign" : roles.SMADriver ? "Assign To Me" : "",
        hospitalSelectArrow: roles.isAdmin || permissions.canViewScheduleAsSMA ? true : false,
        isSMADriver: roles.SMADriver,
        isAdmin: roles.isAdmin,
        adminNavbar: roles.isAdmin,
        isVehicleAllocated: (authStore?.vehicleNumber) ? true : false
    }
}


const getButtonNameForDirver = (calloutStatus: number, isMyVehicle: boolean) => {
    switch (calloutStatus) {
        case CalloutStatuses.dispatchedToTeam:
            return 'Assign To Me';
        case  CalloutStatuses.teamAcknowledged:
            return isMyVehicle?'Depart For Site':'Assign To Me';
        case CalloutStatuses.enRouteToDestination:
            return isMyVehicle?'On Site':'En Route';
        case CalloutStatuses.teamOnSite:
            return  isMyVehicle?'Leave Site':'On Site';        
        default:
            return '';
    }
}

const getLabelNameForDirver = (calloutStatus: number, isMyVehicle: boolean, assignedVehicle: string) => {
    switch (calloutStatus) {
        case  CalloutStatuses.teamAcknowledged:
            return `Assigned to ${isMyVehicle?"me":assignedVehicle}`;
        case CalloutStatuses.enRouteToDestination:
            return isMyVehicle?'En Route': `Assigned to ${assignedVehicle}`; 
        case CalloutStatuses.teamOnSite:
            return isMyVehicle?'On Site': `Assigned to ${assignedVehicle}`; 
       
        default:
            return '';
    }
}

export {
    getRoles,
    getButtonNameForDirver,
    getLabelNameForDirver
}